import styled from 'styled-components';
import { Menu } from 'antd';

export default styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background-color: var(--white);
`;

export const SpaceOffset = styled.div`
  height: 64px;
`;

export const HeaderStyled = styled.div`
  height: 64px;
  width: 100%;
  background-color: var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 33px 0 40px;
  box-shadow: 0 2px 6px 0 rgb(0 0 0 / 40%);
`;

export const LeftStyled = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  & .logo-header {
    margin-right: 9px;
    height: 64px;
    /* margin-left: -40px; */
    padding: 10px 10px 10px 0;
  }

  .btn-back {
    display: flex;
    align-items: center;
    padding-left: 0;
    padding-right: 0;

    span {
      line-height: 24px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 154px;
    }
  }
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 154px;
  }
`;

export const CenterStyled = styled.div`
  display: flex;
  justify-content: center;
`;

export const TabSelectStyled = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 160px;
  text-align: center;
  padding: 9px 29px;
  font-family: var(--font-family);
  font-size: 14px;
  cursor: pointer;
  &.tab-selected {
    color: var(--white);
    border-radius: 20px;
    background: linear-gradient(149.45deg, #3c82c0 0%, var(--border-color-base) 100%);
  }
  .text {
    letter-spacing: 0.5px;
    line-height: 14px;
    font-weight: 600;
    cursor: pointer;
  }
`;

export const UserInfoWrapper = styled.span`
  display: flex;
  align-items: center;
  padding: 12px 12px 12px 0;
  cursor: pointer;

  & .user-info {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100px;
    margin: 0 8px;
    color: #333333;
  }
`;

export const RightStyled = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;

  .notify-header {
    display: flex;
    align-items: center;
    margin-right: 40px;
    cursor: pointer;
    color: #333333;

    .badge {
      .ant-badge-count {
        min-width: 16px;
        height: 16px;
        font-size: 8px;
        letter-spacing: 0;
        line-height: 12px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #e65050;
        transform: translate(35%, -25%);
        .ant-scroll-number-only {
          height: auto;
        }
      }
    }
    span {
      &:nth-child(2) {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 56px;
      }
    }
  }

  & .ant-dropdown {
    box-shadow: var(--box-shadow);
  }
`;

export const MenuDropdownUserStyled = styled(Menu)`
  && {
    /* width: 240px; */
    border-radius: 9px;
    box-shadow: var(--box-shadow);

    .menu-item {
      height: auto;
    }

    .ant-menu-item {
      padding: 2px 32px;
    }

    .box-userinfo-header {
      .user-name {
        color: var(--black);
        font-weight: 600;
      }
      .user-address {
        color: var(--black);
        font-weight: 300;
        line-height: 14px;
        margin-top: -8px;
      }
    }
  }
`;
